import _pt from "prop-types";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import React from 'react';
import classNames from 'classnames';
import { Heading } from '@lmig/lmds-react-typography';
import { A11yOnly } from '@lmig/lmds-react-a11y';
import "./field.css";

// @TODO Fix this in the next major release.
// eslint-disable-next-line @typescript-eslint/naming-convention
var groupFieldTypes = ['radio', 'checkbox', 'visualRadio', 'visualCheckbox'];
var FieldLabel = function FieldLabel(_ref) {
  var _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    id = _ref.id,
    isRequired = _ref.isRequired,
    _ref$labelA11y = _ref.labelA11y,
    labelA11y = _ref$labelA11y === void 0 ? '' : _ref$labelA11y,
    labelId = _ref.labelId,
    _ref$labelStyle = _ref.labelStyle,
    labelStyle = _ref$labelStyle === void 0 ? 'div' : _ref$labelStyle,
    labelVisual = _ref.labelVisual,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'alphanumeric' : _ref$type,
    value = _ref.value;
  var hasLabel = (labelVisual || labelA11y || disabled || (type === 'checkbox' || type === 'visualCheckbox') && isRequired && !disabled) && type !== 'hidden';
  var isGroupField = groupFieldTypes.includes(type);
  var GroupFieldLabel = labelStyle !== 'div' ? Heading : 'div';
  var getFieldId = function getFieldId() {
    var labels = {
      select: 'select',
      alphanumeric: 'input',
      radio: 'radio',
      checkbox: 'checkbox',
      textarea: 'textarea',
      visualRadio: 'visualRadio',
      visualCheckbox: 'visualCheckbox',
      hidden: 'hidden'
    };
    return id ? "".concat(id, "-").concat(labels[type]) : "".concat(labelId, "-").concat(labels[type]);
  };
  function renderLabelContent() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, labelVisual && /*#__PURE__*/React.createElement("span", {
      "aria-hidden": !!labelA11y
    }, labelVisual), labelA11y && /*#__PURE__*/React.createElement(A11yOnly, null, labelA11y), (type === 'checkbox' || type === 'visualCheckbox') && isRequired && !disabled && /*#__PURE__*/React.createElement(A11yOnly, null, "Please select at least one option."), disabled && value && /*#__PURE__*/React.createElement(A11yOnly, null, "This field is prefilled and cannot be modified."), disabled && !value && /*#__PURE__*/React.createElement(A11yOnly, null, "This field is disabled."), loading && /*#__PURE__*/React.createElement(A11yOnly, null, "Loading options, please wait."));
  }
  var fieldLabel = isGroupField ? /*#__PURE__*/React.createElement("legend", {
    className: "lm-Field-legend"
  }, /*#__PURE__*/React.createElement(GroupFieldLabel, {
    id: "".concat(getFieldId(), "-label"),
    className: "lm-FieldGroup-fieldLabel",
    type: labelStyle !== 'div' ? labelStyle : undefined
  }, renderLabelContent())) : /*#__PURE__*/React.createElement("label", {
    id: "".concat(getFieldId(), "-label"),
    className: "lm-FieldGroup-fieldLabel",
    htmlFor: getFieldId()
  }, renderLabelContent());
  return hasLabel ? fieldLabel : null;
};
FieldLabel.propTypes = {
  /** Add an optional ID to element with the class `lm-FieldGroup-fieldLabel`. */id: _pt.string,
  /** Add custom classes to element with the class `lm-FieldGroup-fieldLabel`. */className: _pt.string,
  /** If your Select is populated conditionally, or dependent on a service call,
     * you can put it into a loading state while the results return by toggling the `loading` boolean.
     * You must then conditionally change the label text to indicate that content is loading,
     * and/or supply a loading icon or animation to the Select `loadingIcon` prop. */
  loading: _pt.bool,
  /** Adds extra messaging to the a11y label as well as a CSS class. */disabled: _pt.bool,
  /** Adds a label to an input field. */labelVisual: _pt.node,
  /** Adds a label accessible via screen readers. */labelA11y: _pt.node,
  /** Customizes inpute label tag.
     * This only works with 'radio', 'checkbox', 'visualRadio', 'visualCheckbox' field types. */
  labelStyle: _pt.oneOfType([_pt.oneOf(['h2', 'h2-bold', 'h2-medium', 'h2-light', 'h3', 'h3-bold', 'h3-medium', 'h3-light', 'h4', 'h4-bold', 'h4-medium', 'h4-light', 'h5', 'h5-bold', 'h5-medium', 'h6', 'h6-bold', 'h6-medium', 'h6-small', 'h6-small-bold', 'h6-small-medium']), _pt.oneOf(['div'])]),
  /** Associates a label with an element via a custom id. If labelId is blank, a default id is provided. */labelId: _pt.string,
  /** Prefills the input field with a value. */value: _pt.string,
  /** Specifies the type of input. */type: _pt.oneOf(['select', 'alphanumeric', 'radio', 'checkbox', 'visualCheckbox', 'visualRadio', 'textarea', 'hidden']),
  /** Marks the group as 'required' for screen readers.
     * @default 'false'
     */
  isRequired: _pt.bool,
  /** Set the content. */children: _pt.node
};
export var Field = function Field(props) {
  var id = props.id,
    type = props.type,
    loading = props.loading,
    disabled = props.disabled,
    _props$isFocused = props.isFocused,
    isFocused = _props$isFocused === void 0 ? false : _props$isFocused,
    _props$isForceFloat = props.isForceFloat,
    isForceFloat = _props$isForceFloat === void 0 ? false : _props$isForceFloat,
    _props$isPopulated = props.isPopulated,
    isPopulated = _props$isPopulated === void 0 ? false : _props$isPopulated,
    _props$isRequired = props.isRequired,
    isRequired = _props$isRequired === void 0 ? false : _props$isRequired,
    highlightType = props.highlightType,
    _props$inline = props.inline,
    inline = _props$inline === void 0 ? false : _props$inline,
    helpText = props.helpText,
    className = props.className,
    children = props.children;
  var ariaProps = {};
  var Wrapper = type === 'checkbox' || type === 'visualCheckbox' ? 'fieldset' : 'div';
  if ((type === 'radio' || type === 'visualRadio') && isRequired) {
    ariaProps['aria-required'] = 'true';
  }
  function getWrapperClassName() {
    return classNames('lm-FieldGroup-wrapper', {
      'is-error': highlightType === 'error',
      'is-forceFloat': isForceFloat,
      'is-populated': isPopulated,
      'is-focused': isFocused,
      'is-loading': loading,
      'is-disabled': disabled,
      'is-inline': inline
    }, className);
  }
  var fieldModifier = type && {
    alphanumeric: 'lm-FieldGroup-field--input',
    checkbox: 'lm-FieldGroup-field--checkbox',
    radio: 'lm-FieldGroup-field--radio',
    visualCheckbox: 'lm-FieldGroup-field--visualCheckbox',
    visualRadio: 'lm-FieldGroup-field--visualRadio',
    select: 'lm-FieldGroup-field--select',
    textarea: 'lm-FieldGroup-field--textarea',
    hidden: ''
  }[type];
  return /*#__PURE__*/React.createElement("div", {
    className: getWrapperClassName(),
    id: id
  }, /*#__PURE__*/React.createElement(Wrapper, _extends({
    className: classNames('lm-FieldGroup-field', fieldModifier),
    role: type === 'radio' || type === 'visualRadio' ? 'radiogroup' : undefined
  }, ariaProps), /*#__PURE__*/React.createElement(FieldLabel, props), /*#__PURE__*/React.createElement("div", {
    className: "lm-FieldGroup-inner"
  }, children, helpText && /*#__PURE__*/React.createElement("div", {
    className: "lm-FieldGroup-helpText"
  }, helpText))));
};
Field.propTypes = {
  /** Add an optional ID to the element with the class `lm-FieldGroup-wrapper`. */id: _pt.string,
  /** Add custom classes to the element with the class `lm-FieldGroup-wrapper`. */className: _pt.string,
  /** Prefills the input field with a value. */value: _pt.string,
  /** Specifies the type of input. */type: _pt.oneOf(['select', 'alphanumeric', 'radio', 'checkbox', 'visualCheckbox', 'visualRadio', 'textarea', 'hidden']),
  /** If your Select is populated conditionally, or dependent on a service call,
     * you can put it into a loading state while the results return by toggling the `loading` boolean.
     * You must then conditionally change the label text to indicate that content is loading,
     * and/or supply a loading icon or animation to the Select `loadingIcon` prop. */
  loading: _pt.bool,
  /** Adds extra messaging to the a11y label as well as a CSS class. */disabled: _pt.bool,
  /** Adds a class to the FieldGroup wrapper for targeting elements that can't be targeted with pseudo classes.
     * @default 'false'
     */
  isFocused: _pt.bool,
  /** Force floats the label up even when there's no value for 'date', 'datetime-local', 'month',
     * 'week', and 'time' types.
     * Used in AlphanumericInput to prevent the label covering up browser native placeholders.
     * @default 'false'
     */
  isForceFloat: _pt.bool,
  /** Floats the label up when the field is populated.
     * @default 'false'
     */
  isPopulated: _pt.bool,
  /** Adds a label to an input field. */labelVisual: _pt.node,
  /** Adds a label accessible via screen readers. */labelA11y: _pt.node,
  /** Customizes inpute label tag.
     * This only works with 'radio', 'checkbox', 'visualRadio', 'visualCheckbox' field types. */
  labelStyle: _pt.oneOfType([_pt.oneOf(['h2', 'h2-bold', 'h2-medium', 'h2-light', 'h3', 'h3-bold', 'h3-medium', 'h3-light', 'h4', 'h4-bold', 'h4-medium', 'h4-light', 'h5', 'h5-bold', 'h5-medium', 'h6', 'h6-bold', 'h6-medium', 'h6-small', 'h6-small-bold', 'h6-small-medium']), _pt.oneOf(['div'])]),
  /** Associates a label with an element via a custom id. If labelId is blank, a default id is provided. */labelId: _pt.string,
  /** Adds help text under an input field. */helpText: _pt.node,
  /** Highlights the field in an error state. */highlightType: _pt.oneOf(['error']),
  /** Styles radio fields side-by-side.
     * @default 'false'
     */
  inline: _pt.bool,
  /** Marks the group as 'required' for screen readers.
     * @default 'false'
     */
  isRequired: _pt.bool,
  /** Set the content inside of this element: `<div className="lm-FieldGroup-inner">`. */children: _pt.node
};